module.exports = __webpack_public_path__ + "static/img/select-logo-alt.b509d281.svg";